import React from "react";
import { Button } from "reactstrap";
import DataTable from "../../../shared/components/table/dataTable";
import { withRouter } from "react-router-dom";

const SiteTable = ({ tableCardData, history }) => {
  const tableHeaders = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "total_devices",
      headerName: "Total Devices",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "actions",
      type: "actions",
      renderCell: (params) => (
        <div className="material_data_table__cell_btn">
          <Button
            className="icon btn btn-small"
            color="primary"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              history.push(`/site/${params.row.id}/overview`);
            }}
          >
            View Site
          </Button>
        </div>
      ),
      flex: 1,
      minWidth: 150,
    },
  ];

  const createData = (data) => {
    var array = [];
    if (data && data.length > 0) {
      data.forEach((element) => {
        array.push({
          id: element.id,
          name: element.name,
          total_devices: element.total_devices,
        });
      });
    }
    return array;
  };

  return <DataTable columns={tableHeaders} rows={createData(tableCardData)} tableSize={10} disableFiltering={true} showToolbar={true} rowOnClickPath={"site/id/overview"} />;
};

export default withRouter(SiteTable);
